import { render, staticRenderFns } from "./project_detail.vue?vue&type=template&id=f990829a&scoped=true&"
import script from "./project_detail.vue?vue&type=script&lang=js&"
export * from "./project_detail.vue?vue&type=script&lang=js&"
import style0 from "./project_detail.vue?vue&type=style&index=0&id=f990829a&prod&lang=scss&scoped=true&"
import style1 from "./project_detail.vue?vue&type=style&index=1&id=f990829a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f990829a",
  null
  
)

export default component.exports